export const GET_COMPANY_DASHBOARD_OVERVIEW_REQUEST =
  "GET_COMPANY_DASHBOARD_OVERVIEW_REQUEST";
export const GET_COMPANY_DASHBOARD_OVERVIEW_RESPONSE =
  "GET_COMPANY_DASHBOARD_OVERVIEW_RESPONSE";
export const GET_COMPANY_DASHBOARD_ONGOING_EVENTS_REQUEST =
  "GET_COMPANY_DASHBOARD_ONGOING_EVENTS_REQUEST";
export const GET_COMPANY_DASHBOARD_ONGOING_EVENTS_RESPONSE =
  "GET_COMPANY_DASHBOARD_ONGOING_EVENTS_RESPONSE";
export const GET_COMPANY_DASHBOARD_OVERVIEW_FAILURE =
  "GET_COMPANY_DASHBOARD_OVERVIEW_FAILURE";
export const GET_COMPANY_DASHBOARD_ONGOING_EVENTS_FAILURE =
  "GET_COMPANY_DASHBOARD_ONGOING_EVENTS_FAILURE";
export const GET_COMPANY_DASHBOARD_CLIENT_SATISFACTION_REQUEST =
  "GET_COMPANY_DASHBOARD_CLIENT_SATISFACTION_REQUEST";
export const GET_COMPANY_DASHBOARD_CLIENT_SATISFACTION_RESPONSE =
  "GET_COMPANY_DASHBOARD_CLIENT_SATISFACTION_RESPONSE";
export const GET_COMPANY_DASHBOARD_CLIENT_SATISFACTION_FAILURE =
  "GET_COMPANY_DASHBOARD_CLIENT_SATISFACTION_FAILURE";
export const GET_COMPANY_DASHBOARD_TOP_EVENTS_REQUEST =
  "GET_COMPANY_DASHBOARD_TOP_EVENTS_REQUEST";
export const GET_COMPANY_DASHBOARD_TOP_EVENTS_RESPONSE =
  "GET_COMPANY_DASHBOARD_TOP_EVENTS_RESPONSE";
export const GET_COMPANY_DASHBOARD_TOP_EVENTS_FAILURE =
  "GET_COMPANY_DASHBOARD_TOP_EVENTS_FAILURE";
export const GET_COMPANY_DASHBOARD_RECENT_ACTIVITY_REQUEST =
  "GET_COMPANY_DASHBOARD_RECENT_ACTIVITY_REQUEST";
export const GET_COMPANY_DASHBOARD_RECENT_ACTIVITY_RESPONSE =
  "GET_COMPANY_DASHBOARD_RECENT_ACTIVITY_RESPONSE";
export const GET_COMPANY_DASHBOARD_RECENT_ACTIVITY_FAILURE =
  "GET_COMPANY_DASHBOARD_RECENT_ACTIVITY_FAILURE";
